/* When all <scroll-carousel> is in view, animate scrollLeft 100px and back to 0px, de this the first 3 times then stop. 
* Set every try as a cookie so it doesn't repeat on page refresh.
*/

// If shopify design mode is active, don't run the script
if (window.Shopify && !Shopify.designMode){

    // Helpers
    function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
    function easeOutQuad(t) {
        return t * (2 - t);
    }
    function easeInQuad(t) {
        return t * t;
    }

    // Get the collection-list element
    const scrollCarousels = document.querySelectorAll('scroll-carousel.collection-list');
    let tries = 0;
    let triesPerPage = 0;
    const maxTriesPerPage = 2;
    const maxTries = 6;
    const cookieName = 'scrollCarouselTries';

    let programmaticScroll = false;

    // Check if the cookie exists
    if (document.cookie.indexOf(cookieName) >= 0) {
        tries = parseInt(document.cookie.replace(/(?:(?:^|.*;\s*)scrollCarouselTries\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
    }

    function smoothScrollTo({ element, target, duration, direction = 'forward' }) {
        const start = element.scrollLeft;
        const change = target - start;
        const startTime = performance.now();

        function animateScroll(currentTime) {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            element.scrollLeft = start + change * (direction === 'forward' ? easeOutQuad(progress) : easeInOutQuad(progress));

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            }
        }

        requestAnimationFrame(animateScroll);
    }

    // Usage example:


    // IntersectionObserver callback
    function handleIntersection(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting && tries < maxTries && triesPerPage < maxTriesPerPage) {
                const element = entry.target;
                if (element.hasAttribute('animating')) return;
                programmaticScroll = true;
                element.setAttribute('animating', 'true');

                const targetPosition = element.scrollLeft + 100; // Target scroll position (150px to the right)
                const targetPositionBack = element.scrollLeft; // Target scroll position (back to 0px)
                const duration = 1000; // Duration in milliseconds

                smoothScrollTo({ element, target: targetPosition, duration });
                setTimeout(() => {
                    smoothScrollTo({ element, target: targetPositionBack, duration, direction: 'backward' });
                }, duration);

                setTimeout(() => {
                    element.removeAttribute('animating');
                    programmaticScroll = false;
                }, duration * 2);

                tries++;
                triesPerPage++;
                document.cookie = cookieName + "=" + tries + "; path=/";
            }
        });
    }

    // Create an IntersectionObserver
    var observer = new IntersectionObserver(handleIntersection, {
        root: null,
        rootMargin: '0px',
        threshold: 1.0
    });

    // Observe each scroll-carousel element
    scrollCarousels.forEach(carousel => {
        observer.observe(carousel);

        carousel.addEventListener('scroll', function(e) {
            if (e.isTrusted && !programmaticScroll) {
                document.dispatchEvent(new CustomEvent('scrollCarousel:stop'));
            }
        }, { once: true });

        document.addEventListener('scrollCarousel:stop', function() {
            observer.unobserve(carousel);
        });
    });
} 

// logic for mega menu

document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('.category-trigger');
    const subcategoryGroups = document.querySelectorAll('.subcategory-group');
    const closeButtons = document.querySelectorAll('.mega-menu__close');
    const brandItems = document.querySelectorAll('.brand-item');
    const staticBrandItems = document.querySelectorAll('.brand-item--static');

    // Global variable to track if any mega menu is currently open
    let isMegaMenuOpen = false;

    // Function to prevent background scrolling
    function preventBackgroundScroll(enable) {
        if (enable && !isMegaMenuOpen) {
            document.body.style.overflow = 'hidden';
            document.body.dataset.scrollPosition = window.scrollY;
            isMegaMenuOpen = true;
        } else if (!enable && isMegaMenuOpen) {
            const scrollY = document.body.dataset.scrollPosition || '0';
            document.body.style.overflow = '';
            window.scrollTo(0, parseInt(scrollY));
            isMegaMenuOpen = false;
        }
    }

    // Function to check if any mega menu is currently visible/open
    function checkIfAnyMenuOpen() {
        const openDisclosures = document.querySelectorAll('.header__menu-disclosure[open][aria-expanded="true"]');
        return openDisclosures.length > 0;
    }

    // Modify the text content of all the triggers that are "Fremhavet" into "Fremhævet"
    triggers.forEach(trigger => {
        if (trigger.dataset.category === 'fremhavet') {
            trigger.textContent = 'Fremhævet';
        }
    });
  
    // Select the containers
    const kategorierLists = document.querySelectorAll('.kategorier-list');
    const fokusColumns = document.querySelectorAll('.fokus-column');     
  
    // Variables to store state
    let lastRenderedSubcategoryGroup = null;
    let lastNyhedBrands = []; // Store brands from fremhavet
  
    // Close buttons across all mega menus
    closeButtons.forEach(closeBtn => {
      closeBtn.addEventListener('click', () => {
        const megaMenuDisclosure = closeBtn.closest('.header__menu-disclosure');
        const megaMenu = closeBtn.closest('.mega-menu');
  
        if (megaMenuDisclosure) {
            megaMenuDisclosure.setAttribute('aria-expanded', 'false');
            // Check if any other menu is open before enabling scrolling
            setTimeout(() => {
                if (!checkIfAnyMenuOpen()) {
                    preventBackgroundScroll(false);
                }
            }, 50);
        }
      });
    });
  
    // Hover trigger logic
    triggers.forEach(trigger => {
      if (!trigger.dataset.category) {
        console.warn('Mega menu: Trigger missing data-category', trigger);
        return;
      }
  
      trigger.addEventListener('mouseenter', () => {
        const targetCategory = trigger.dataset.category.toLowerCase();
        const navItem = trigger.closest('.header__primary-nav-item');
        const parentContext = navItem?.dataset.title?.toLowerCase();
  
        // BRANDS section
        if (parentContext === 'brands') {
          // Hide all dynamic brand items only
          brandItems.forEach(item => {
            if (!item.classList.contains('brand-item--static')) {
              item.style.display = 'none';
            }
          });
  
          // Re-show static brand items for Brands
          const activeMegaMenu = trigger.closest('.mega-menu');
          const visibleBrandItems = activeMegaMenu?.querySelectorAll('.brand-item--static');
          visibleBrandItems?.forEach(item => {
            item.style.display = 'block';
          });
  
          return;
        }
  
        // NON-BRANDS filtering (Dame, Herre, Livsstil, etc.)
  
        // Find matched subcategories
        const matchedGroups = document.querySelectorAll(
          `.subcategory-group[data-category*="${targetCategory}"]`
        );
  
        // If there are no matching subcategories, retain the last rendered one
        if (matchedGroups.length === 0) {
          if (lastRenderedSubcategoryGroup) {
            lastRenderedSubcategoryGroup.hidden = false;
          }
        } else {
          // Hide all subcategory groups
          subcategoryGroups.forEach(group => {
            if (group && group.hidden !== undefined) {
              group.hidden = true;
            }
          });
  
          // Show matched subcategories and update the last rendered group
          matchedGroups.forEach(group => {
            if (group && group.hidden !== undefined) {
              group.hidden = false;
              lastRenderedSubcategoryGroup = group;
            }
          });
        }
  
        // Special handling for udsalg
        if (targetCategory === 'udsalg') {
          if (lastNyhedBrands.length === 0) {
            const nyhedTrigger = document.querySelector('.category-trigger[data-category="fremhavet"]');
            if (nyhedTrigger) {
              nyhedTrigger.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
            }
          }
  
          // Hide all dynamic brand items
          brandItems.forEach(brandItem => {
            if (!brandItem.classList.contains('brand-item--static')) {
              brandItem.style.display = 'none';
            }
          });
  
          // Show brands from fremhavet
          lastNyhedBrands.forEach(brandItem => {
            brandItem.style.display = 'block';
          });
  
          return;
        }
  
        // Hide all brand items (except static ones)
        brandItems.forEach(brandItem => {
          if (!brandItem.classList.contains('brand-item--static')) {
            brandItem.style.display = 'none';
          }
        });
  
        // Show only matching brands (not static ones)
        const matchingBrands = [];
        brandItems.forEach(brandItem => {
          if (brandItem.classList.contains('brand-item--static')) return;
  
          const brandTags = brandItem.dataset.tags?.toLowerCase().split(',').map(t => t.trim()) || [];
          const brandParents = brandItem.dataset.parent?.toLowerCase().split(',').map(p => p.trim()) || [];
  
          const isCorrectCategory = brandTags.includes(targetCategory);
          const isCorrectParent = brandParents.includes(parentContext);
  
          // Conditional logic for brands with fremhavet category
          if (targetCategory === 'fremhavet') {
            let isVisibleInContext = false;
            // Check if the visibility dataset has entries
            if (brandItem.dataset.visibility) {
              const visibilityItems = brandItem.dataset.visibility.split(',').map(v => v.trim());
              if (visibilityItems.length > 0) {
                visibilityItems.forEach(vis => {
                    const [ visParent, visCategory ] = vis.split('_').map(v => v.toLowerCase());
                    if (visParent === parentContext && visCategory === targetCategory) {
                      isVisibleInContext = true;
                    }
                });
              }
            }
            if (isVisibleInContext) {
              brandItem.style.display = 'block';
              matchingBrands.push(brandItem);
            }
         } else {
            // For other categories, use the original logic
            if (isCorrectCategory && isCorrectParent) {
              brandItem.style.display = 'block';
              matchingBrands.push(brandItem);
            }
          }
        });
  
        // If the target category is fremhavet, store these brands for later use
        if (targetCategory === 'fremhavet') {
          lastNyhedBrands = matchingBrands;
        }
      });
    });
  
    // Dynamically modify the titles for the "Brands" section
    const megaMenus = document.querySelectorAll('.mega-menu');
    megaMenus.forEach(menu => {
      const navItem = menu.closest('.header__primary-nav-item');
      const parentTitle = navItem?.dataset.title?.toLowerCase();
  
      if (parentTitle === 'brands') {
        const fokusHeading = menu.querySelector('.fokus-column h4');
        const kategorierHeading = menu.querySelector('.kategorier-column h4');
        const brandsHeading = menu.querySelector('.brands-column h4');

        // the translations can be found in mega-menu.liquid
  
        if (fokusHeading) fokusHeading.textContent = window.theme.strings.popularBrands;
        if (kategorierHeading) kategorierHeading.textContent = window.theme.strings.accessories;
        if (brandsHeading) brandsHeading.textContent = window.theme.strings.lifestyle;
      }
    });

    // create a variable to store the current open mega menu
    let activeNavItem = null;

    // Create a MutationObserver to monitor menu open/close status
    const menuObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'open' || mutation.attributeName === 'aria-expanded') {
                // Check if any menu is open
                const isAnyMenuOpen = checkIfAnyMenuOpen();
                preventBackgroundScroll(isAnyMenuOpen);
            }
        });
    });

    // Observer configuration
    const observerConfig = { attributes: true, attributeFilter: ['open', 'aria-expanded'] };

    // Start observing all disclosures
    document.querySelectorAll('.header__menu-disclosure').forEach(disclosure => {
        menuObserver.observe(disclosure, observerConfig);
    });

    // === DEFAULT SUBCATEGORY FOR DAME, HERRE, LIVSSTIL ===
    const topNavItems = document.querySelectorAll('.header__primary-nav-item[data-title]');
    topNavItems.forEach(navItem => {
      navItem.addEventListener('mouseenter', () => {
            // logic to close the mega menu before the next one appears
            // this prevents an overlapping that creates a 1s color glitch
            if (activeNavItem !== navItem) {
                    if (activeNavItem) {
                        const activeDisclosure = activeNavItem.querySelector('.header__menu-disclosure[open]');
                        if (activeDisclosure) {
                            activeDisclosure.open = false;
                            activeDisclosure.setAttribute('aria-expanded', 'false');
                        
                            const activeMegaMenu = activeDisclosure.querySelector('.mega-menu');
                            if (activeMegaMenu) {
                                activeMegaMenu.style.opacity = '0';
                            }
                        }
                    }
        
                activeNavItem = navItem;
            
                const newDisclosure = navItem.querySelector('.header__menu-disclosure');
                if (newDisclosure) {
                    newDisclosure.open = true;
                    newDisclosure.setAttribute('aria-expanded', 'true');
                
                    const newMegaMenu = newDisclosure.querySelector('.mega-menu');
                    if (newMegaMenu) {
                        newMegaMenu.style.opacity = '1';
                    }
                }
            }
        
        const parentContext = navItem.dataset.title?.toLowerCase();
        if (parentContext === 'brands') return; // Skip for brands
  
        let defaultCategory = null;
        if (parentContext === 'dame' || parentContext === 'herre') {
          defaultCategory = 'fremhavet';
        } else if (parentContext === 'livsstil') {
          defaultCategory = 'fremhavet';
        }
  
        if (defaultCategory) {
          const defaultTrigger = navItem.querySelector(`.category-trigger[data-category="${defaultCategory}"]`);
          if (defaultTrigger) {
            defaultTrigger.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
          }
        }
      });
    });
});

function initRebuyCart() {
  document.addEventListener("rebuy:smartcart.ready", (event) => {
    addPaymentIcons();
    runRebuyCode(event.detail.smartcart.cart);
  });

  document.addEventListener("rebuy:cart.change", (event) => {
    const cart = event.detail.cart.cart;
    runRebuyCode(cart);
    addPaymentIcons();
  });
}

function runRebuyCode(cart) {
  addPaymentIcons();
}

function addPaymentIcons() {
  setTimeout(() => {
    const paymentIcons = document.querySelector(
      "ul.cart__drawer__payment__icons"
    );
    const checkoutArea = document.querySelector(
      'div[data-rebuy-component="checkout-area"]'
    );

    if (checkoutArea && paymentIcons) {
      const existingPaymentIcons = checkoutArea.querySelector(
        "ul.cart__drawer__payment__icons"
      );
      if (existingPaymentIcons) {
        existingPaymentIcons.remove();
      }

      const clonedPaymentIcons = paymentIcons.cloneNode(true);
      checkoutArea.appendChild(clonedPaymentIcons);
    }
  }, 500);
}

initRebuyCart();